<template>
    <v-tooltip bottom color="primary" :disabled="readonly">
        <template v-slot:activator="{ on, attrs }">
            <v-icon
                    :color="iconColor"
                    class="mr-2"
                    :class="{'pointer': !readonly, 'readonly': readonly}"
                    small
                    v-bind="attrs"
                    @click="handleClick"
                    v-on="on">
                {{ icon }}
            </v-icon>
        </template>
        <span class="secondary--text">{{ tooltip }}</span>
    </v-tooltip>
</template>

<script>
export default {
  name: "TableAction",
  props: {
    icon: {
      type: String,
      required: true,
    },
    tooltip: {
      type: String,
      required: true,
    },
    iconColor: {
      type: String,
      required: false,
      default: 'primary'
    },
    readonly: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  methods: {
    handleClick(event) {
      if (this.readonly) {
        return;
      }
      this.$emit('click');
      event.target.blur();
    }
  }
};
</script>

<style lang="scss" scoped>

.readonly ::v-deep {
    cursor: unset!important;
  }


</style>